import { LegalPageLayout } from '@/components/legal-page-layout'

export default function LegalRefund() {
  return (
    <LegalPageLayout title="Refund Policy" lastUpdated="January 12, 2025">
      <section className="mb-6">
        <p className="mb-4">
          Bad refund policies are infuriating. You feel like the company is just trying to rip you off. We never want
          our customers to feel that way, so our refund policy is simple: We offer a 30-day money back guarantee on all
          our plans. If you&apos;re not satisfied with our Service within your first 30 days, we&apos;ll refund 100% of
          your payment - no questions asked. Beyond that period, if you&apos;re ever unhappy with our Service for any
          reason, just contact our support team and we&apos;ll take care of you.
        </p>

        <h2 className="mb-2 text-xl">Examples of Full Refunds We&apos;d Grant</h2>
        <ul className="mb-4 list-inside list-disc space-y-2">
          <li>
            If you&apos;re within your first 30 days of using our Service and decide it&apos;s not right for you,
            we&apos;ll give you a complete refund.
          </li>
          <li>
            If you were just charged for your next month of Service but you meant to cancel, we&apos;re happy to refund
            that extra charge.
          </li>
          <li>
            If you forgot to cancel your account a couple months ago and you haven&apos;t used it since then, we&apos;ll
            give you a full refund for a few back months. No problem.
          </li>
        </ul>

        <h2 className="mb-2 text-xl">Examples of Partial Refunds or Credits We&apos;d Grant</h2>
        <ul className="mb-4 list-inside list-disc space-y-2">
          <li>
            If you forgot to cancel your account a year ago, and there&apos;s been activity on your account since then,
            we&apos;ll review your account usage and figure out a partial refund based on how many months you used it.
          </li>
          <li>
            If you upgraded your account a few months ago to a higher plan and kept using it in general but you
            didn&apos;t end up using the extra features, we&apos;d consider applying a prorated credit towards future
            months.
          </li>
          <li>
            If we had extended downtime (multiple hours in a day, or multiple days in a month) or you emailed customer
            service and it took a week to get back to you, we&apos;d issue a partial credit to your account.
          </li>
        </ul>

        <h2 className="mb-2 text-xl">Get in Touch</h2>
        <p className="mb-4">
          At the end of the day, nearly everything on the edges comes down to a case-by-case basis. Send us a note, tell
          us what&apos;s up, and we&apos;ll work with you to make sure you&apos;re happy.
        </p>

        <p>
          If you have any questions about our Refund Policy or would like to request a refund, please contact us at{' '}
          <a href="mailto:support@gitdigest.ai" className="decoration-golden-500 hover:text-golden-500 underline">
            support@gitdigest.ai
          </a>
          .
        </p>
      </section>
    </LegalPageLayout>
  )
}
